<template>
    <DataTable
            v-redirect-if-no-permission:TYPES
            :url="api.ACTIONS.NATIONALITIES"
            :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="{name : 'v-text-field'}"
            :titles="titles"
            title="Nationalities"/>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "Nationalities",
        title: 'Nationalities',
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": "Name",
                    "created_at": "Created At",
                    "updated_at": "Updated At"
                }
            }
        }
    }
</script>

<style scoped>

</style>